import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const AreaDetailsForm = (props) => {
  const [stationData, setStationData] = useState("");
  const [stationId, setStationId] = useState(0);
  const [areaName, setAreaName] = useState("");
  const [areaCode, setAreaCode] = useState("");

  const { sendRequest: getAreaData } = useHttp();
  const [areaData, setAreaData] = useState([]);

  const FillDetail = () => {
    getAreaData(
      {
        url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setAreaData(res.data);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getAreaData]);

  const { sendRequest: postAreaDetails } = useHttp();

  const { sendRequest: getStation } = useHttp();
  useEffect(() => {
    getStation(
      {
        url: `/api/station/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setStationData(data.data);
      }
    );
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!props.update) {
      const isExistingArea = areaData.some(
        (area) => area.areaName === areaName
      );

      const isExistingCode = areaData.some(
        (area) => area.areaCode === areaCode
      );

      if (isExistingArea) {
        toast.error("Area name already exists");
        return;
      }
      if (isExistingCode) {
        toast.error("Area code already exists");
        return;
      }
    }
    const data = {
      stationId: stationId,
      areaName: areaName,
      areaCode: areaCode,

      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    };

    console.log("data", data);

    if (props.update) {
      data["areaId"] = props.update.areaId;
    }

    postAreaDetails(
      {
        url: "/api/areaDetails/",
        method: props.update ? "PUT" : "POST",

        body: data,
      },
      (res) => {
        toast.success(`Area Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      setStationId(props.update.stationId);
      setAreaName(props.update.areaName);
      setAreaCode(props.update.areaCode);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Area Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Station Name</label>
                        <select
                          id="station name"
                          className="form-control"
                          required
                          value={stationId}
                          onChange={(e) => {
                            setStationId(e.target.value);
                          }}
                        >
                          <option value="0">Select</option>
                          {stationData &&
                            stationData.map((x) => (
                              <option key={x.stationId} value={x.stationId}>
                                {x.stationName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Area Name</label>
                        <input
                          type={"text"}
                          id={"areaName"}
                          required
                          className="form-control"
                          value={areaName}
                          onChange={(e) => {
                            setAreaName(e.target.value);
                          }}
                          readOnly={props.update}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Area Code </label>
                        <input
                          type={"text"}
                          id={"areaCode"}
                          required
                          className="form-control"
                          value={areaCode}
                          onChange={(e) => {
                            setAreaCode(e.target.value);
                          }}
                          readOnly={props.update}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};
export default AreaDetailsForm;
